export const equalsIgnoreCase = (a, b) => {
  a = a ?? '';
  b = b ?? '';
  return a.toLowerCase() === b.toLowerCase();
};

export const cleanText = (text) => {
    return text.replace(/[^a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ ]/g, '');
  };